// @flow
import { combineActions, handleActions } from 'redux-actions';
import { upsertResources, completeWithError } from 'data/qcsSyncResourceReducerHelpers';
import * as actions from './actions';
import { mkQcsSyncResourceStore } from '../qcsSyncResourceTypes';

const alertRulesReducer = handleActions({
  [actions.getAlertRulesSuccess]:
    (state, { payload: data }) => upsertResources(state, data),
  [actions.updateAlertRulesSuccess]:
    (state, { payload: AlertRulesToUpsert, asyncDispatch }) => {
      asyncDispatch(actions.getAlertRules());
      return upsertResources(state, AlertRulesToUpsert)
    },
  [combineActions(
    actions.getAlertRulesFailure,
    actions.updateAlertRulesFailure,
  )]:
    (state, { payload: error }) => completeWithError(state, error),
}, mkQcsSyncResourceStore());

export const ALERT_RULES_REDUCER_KEY = 'alertRulesStore';
export default alertRulesReducer;
